export const PAUSE_LAP_THRESHOLD_MS = 70_000;

export function lapKey(lap) {
  return `${new Date(lap.lapStart).toISOString()}/${new Date(lap.lapEnd).toISOString()}`;
}

// Mirror: api/shared/pauseLaps.js. Require both a relative and absolute delay.
export function classifyLaps(laps, overrides = [], pauseThresholdMs = PAUSE_LAP_THRESHOLD_MS) {
  const times = laps.map(l => l.lapTimeMs).sort((a, b) => a - b);
  const baseline = times[Math.floor((times.length - 1) / 4)];
  const threshold = Math.max(baseline * 2.5, baseline + 60_000);
  const saved = new Map(overrides.map(o => [lapKey(o), o.isPause]));
  return laps.map(lap => {
    const pauseLocked = lap.lapTimeMs > pauseThresholdMs;
    const pauseDetected = pauseLocked || (times.length >= 3 && lap.lapTimeMs > threshold);
    const pauseOverride = pauseLocked || saved.size === 0 ? null : saved.get(lapKey(lap)) ?? null;
    return {
      ...lap,
      pauseDetected,
      pauseOverride,
      pauseLocked,
      isPause: pauseLocked || (pauseOverride ?? pauseDetected),
    };
  });
}

export function averageStats(laps) {
  const active = laps.filter(l => !l.isPause);
  const totalMs = laps.reduce((sum, l) => sum + l.lapTimeMs, 0);
  const activeMs = active.reduce((sum, l) => sum + l.lapTimeMs, 0);
  const distanceM = active.reduce((sum, l) => sum + l.distanceM, 0);
  return {
    activeLapCount: active.length,
    pauseLapCount: laps.length - active.length,
    avgLapMs: active.length ? activeMs / active.length : null,
    avgSpeedKmh: activeMs > 0 && active.every(l => Number.isFinite(l.distanceM)) ? distanceM / activeMs * 3600 : null,
    fullAvgLapMs: laps.length ? totalMs / laps.length : null,
    activeTimeMs: activeMs,
  };
}
